module.exports = "images/food_cafe.145f908f85f7a1f2f5229be4776675a3.png";